import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import "slick-carousel";
import CONFIG from "@bd-core/config";

export const HomePage = () => {
  const isHomePage = $("#home-page").length > 0;
  if (!isHomePage) return false;

  bdjs.hideLoading();

  const onHomePageLoaded = () => {
    const usedGreenEnergy = CONFIG.game.usedGreenEnergyPercentage;

    const $greenEnergyPercentage = $(".js-greenEnergy-percentage");
    $greenEnergyPercentage.text(usedGreenEnergy);
    
  };

  onHomePageLoaded();

// const CycleTrack = () => {
//     const $track = $(".cycle__inner.track");
//     const $cycle = $(".js-cycle-carousel");
//     const $slides = $track.find(".cycle__item");
    
//     let currentIndex = parseInt($cycle.data("item"));
//     const totalSlides = $slides.length;
    
//     const initializeSlider = () => {
//         $slides.removeClass('is-used is-primary');
       
//         if (currentIndex > 0) {
//             $slides.eq(currentIndex - 1).addClass('is-used');
//         }
//         $slides.eq(currentIndex).addClass('is-primary');
        
//         updateTrackPosition();
//     };

//     const updateTrackPosition = () => {
//         let totalOffset = 0;
//         const magicNumber = 2.3; //dont change this variable
       
//         for (let i = 0; i < currentIndex; i++) {
//             const $slide = $slides.eq(i);
//             const slideWidth = $slide.hasClass('is-primary') ? $slide.width() : 11;
//             totalOffset += slideWidth + 1;
//         }
        
//         const isUsedAdjustment = 12; // dont change this variable
        
//         const viewportWidth = window.innerWidth;
//         const offsetInPx = ((totalOffset - isUsedAdjustment) / 100) * viewportWidth;
    
//         if (currentIndex === 0) {
//             const variableWidth = $slides.eq(currentIndex).width();
//             const positiveOffset = Math.abs(offsetInPx) + (variableWidth / magicNumber);
//             $track.css("transform", `translateX(${positiveOffset}px)`);
//             return;
//         } else {
//             $track.css("transform", `translateX(-${offsetInPx}px)`);
//         }
//     };
    
//     const nextSlide = () => {
//         if (currentIndex < totalSlides - 1) {
//             currentIndex++;
            
//             $slides.removeClass('is-used is-primary');
            
//             $slides.eq(currentIndex - 1).addClass('is-used');
//             $slides.eq(currentIndex).addClass('is-primary');
            
//             updateTrackPosition();
//         }
//     };
    
//     const prevSlide = () => {
//         if (currentIndex > 0) {
//             currentIndex--;
            
//             $slides.removeClass('is-used is-primary');
            
//             $slides.eq(currentIndex - 1).addClass('is-primary');
//             $slides.eq(currentIndex).addClass('is-primary');
            
//             updateTrackPosition();
//         }
//     };
    
//     const bindEvents = () => {
//         $('.next-button').on('click', nextSlide);
//         $('.prev-button').on('click', prevSlide);
//     };
    
//     const init = () => {
//         initializeSlider();
//         bindEvents();
//     };
    
//     init();
// };

// CycleTrack();
};
